import { Navigate, Route, useLocation } from 'react-router';
import { useNavigate } from 'react-router';

import { Trans, useTranslation } from 'react-i18next';

import { lazy } from 'react';
import { AddonsBuyProvider } from '../../../modules/addons';
import { PurchaseProvider } from '../../../modules/purchase';
import {
  ErrorMessage,
  LoadingIndicator,
  useBlocker,
  Modal,
  Button,
  useToggle,
} from '../../../common';
import styled from 'styled-components';
import { useCallback, useMemo, useState, useEffect } from 'react';


const CreateOrganizationPage = lazy(() =>
  import('../../../modules/organizations/create')
);
const EditOrganizationPage = lazy(() =>
  import('../../../modules/organizations/edit')
);
const CreateLocationPage = lazy(() =>
  import('../../../modules/locations/create')
);
const EditLocationPage = lazy(() => import('../../../modules/locations/edit'));
const RenewSubscriptions = lazy(() =>
  import('../../../modules/purchase/renewSubscriptions/renewPurchase')
);
const PurchasePage = lazy(() =>
  import('../../../modules/purchase/purchase/purchasePage')
);
const SaleOrderPage = lazy(() => import('../../../modules/purchase/saleOrder').then((module) => ({
  default: module.SaleOrderPage
})));
const EditZonePage = lazy(() => import('../../../modules/zones/edit'));
const ChangeSubscription = lazy(
  () => import('../../../modules/change').then((module) => ({
    default: module.ChangeSubscription,
  })),
);
const UpgradeSubscription = lazy(() =>
  import('../../../modules/upgrade/upgradeSubscription/upgradeSubscription')
);
const AddonsBuyPage = lazy(() => import('../../../modules/addons/buy/page'));

const StatePreservingNavigate = ({ ...props }) => {
  const location = useLocation();
  return <Navigate {...props} state={location.state} />
};

const MoveToSoundtrack = () => {
  
  //window.open("https://soundtrack.io","_self")

  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();   
  const navigate = useNavigate();
  

  const ModalDescription = styled.p`
    color: ${({ theme }) => theme.dark500};
    font-size: 1.4rem;
    font-weight: 100;
    line-height: 1.4;
    h1 {
      font-size: 1.7rem;
      font-weight: 900;
    }
      h2 {
      font-size: 1.5rem;
      font-weight: 700;
    }
    a {
      font-weight: 900;
      text-decoration: underline;
    }
    strong {
      font-weight: 900;
    }
  `;

  //{t('addons:needSubscription')}
  return (
  <Modal 
        isOpen={isOpen}
        hideHeader
        onClose={()=> navigate(  `/`)}
        isClosable="true"
        onConfirm={()=> window.open("https://app.soundtrack.io/signup/tunifypremium","_self")}
        confirmText={t('migration:confirm')}
        confirmHighlightGradient="nightfall"
        >
          <ModalDescription>{
          <Trans i18nKey="migration:movetosoundtrack">This should be a <a href="https://app.soundtrack.io/signup/tunify?plan=premium" target="_blank" rel="noopener noreferrer">some link</a><h1>titletime</h1><h2>subtitletitletime</h2></Trans>
          }</ModalDescription>
        </Modal>
        );
};


export const OrganizationRouter = [
  <Route path="create" element={<CreateOrganizationPage />} />,
  <Route path=":organizationId">
    <Route path="edit" element={<EditOrganizationPage />} />
    {/* Route path="renew-subscriptions" element={<RenewSubscriptions />} />*/}
    <Route path="renew-subscriptions" element={<MoveToSoundtrack />} />
    {/* <Route path="sale-orders/:saleOrderId" element={<SaleOrderPage />} /> */}
    <Route path="sale-orders/:saleOrderId" element={<MoveToSoundtrack />} />
    <Route path="locations">
      <Route path="create" element={<CreateLocationPage />} />
      <Route path=":locationId">
        <Route path="edit" element={<EditLocationPage />} />
        <Route path="zones/:zoneId">
          <Route path="edit" element={<EditZonePage />} />
          {/*<Route path="change" element={<ChangeSubscription />} />
          <Route path="upgrade" element={<UpgradeSubscription />} />)*/}
          <Route path="purchase">
            <Route
              path=":currentStep"
              element={
                <MoveToSoundtrack />
              }
            />
            <Route
              path="add-ons/:currentStep"
              element={
                <MoveToSoundtrack />
              }
            />
            <Route
              path="wire-transfer"
              element={<MoveToSoundtrack />}
            />
          </Route>
        </Route>
        {/* Deprecated routes */}
        <Route path="renew-subscriptions" element={<MoveToSoundtrack />} />
        <Route path="sale-orders/:saleOrderId" element={<MoveToSoundtrack />} />
      </Route>
    </Route>
  </Route>,
];
